import { isPlainObject } from 'lodash';
import { FAILURE_TYPES, FAILURE_NAMES } from '../../validationConstants';
import { ERROR_LOCALE_KEYS } from '../../../error/errorLocaleKeys';
import fieldValidationService from '../../fieldValidationService';

const OBJECT_ERROR_OBJECT = {
    name: FAILURE_NAMES.object,
    type: FAILURE_TYPES.ERROR,
    message: 'Must be a plain object',
    errorLocaleKey: ERROR_LOCALE_KEYS.VALIDATION.OBJECT,
};

export default (fieldValue, validationConfig) => {
    if (!fieldValue) return;

    if (!isPlainObject(fieldValue)) {
        return {
            ...OBJECT_ERROR_OBJECT,
            details: fieldValue,
        };
    }

    if (validationConfig.keys) {
        const fieldErrors = validationConfig.keys
            .map((keyType) => fieldValidationService(fieldValue[keyType.name], keyType))
            .filter((err) => !!err);

        if (fieldErrors.length) {
            return {
                ...OBJECT_ERROR_OBJECT,
                message: 'Object key validation failed',
                details: fieldErrors,
                errorLocaleKey: ERROR_LOCALE_KEYS.VALIDATION.OBJECT_KEY,
            };
        }
    }

    return null;
};
